import {
    APPSTATE,
    GRIDSTATE,
    HEALTHSTATE,
    LAYOUTSTATE,
    MEMBERSTATE,
    MENUSTATE,
    MODALSTACK,
    MODALSTATE,
    ROOMSSTATE,
    SCREENSTATE,
    SETTINGSSTATE,
    USERSSTATE,
    VIDEOSTATE,
} from '.'
import { Model } from '../../types/state'
import { idToSlug, slugToID } from './internal/users'

export const getState = () => ({
    SETTINGSSTATE,
    GRIDSTATE: GRIDSTATE.grid,
    HEALTHSTATE: HEALTHSTATE.health,
    MENUSTATE: MENUSTATE.menu,
    ROOMSSTATE,
    SCREENSTATE: SCREENSTATE.screen,
    VIDEOSTATE: VIDEOSTATE.video,
    MODALSTATE: MODALSTATE,
    MODALSTACKSTATE: MODALSTACK,
    USERSSTATE,
})

/* App */
export const getAppState = () => APPSTATE.app

/* Menu */
export const getMembersState = () => MEMBERSTATE.members

export const getMenuState = () => MENUSTATE.menu

/* Modals */
export const getModalState = () => MODALSTATE
export const getModalStack = () => MODALSTACK

/* Layout */
export const getPortalState = () => LAYOUTSTATE.portal
export const getLayoutState = () => LAYOUTSTATE.layout

/* Rooms */
export const getRoomsState = () => ROOMSSTATE.rooms

/* Screen */
export const getScreenState = () => SCREENSTATE.screen

/* Settings */
export const getSettingsState = () => SETTINGSSTATE

/* Users */
export const resolveID = (identifier: string | number) =>
    typeof identifier === 'number'
        ? identifier
        : typeof identifier === 'string'
          ? slugToID[identifier?.toLowerCase()]
          : undefined

export const resolveSlug = (identifier: string | number) =>
    typeof identifier === 'string'
        ? idToSlug[identifier] || identifier?.toLowerCase()
        : typeof identifier === 'number'
          ? idToSlug[identifier]
          : undefined

export const getSlugAndId = (
    slugOrId: string | number,
): [slug: string, id: number] => {
    return [resolveSlug(slugOrId), resolveID(slugOrId)] as [
        slug: string,
        id: number,
    ]
}

export const getServerCachedUser = (slugOrId: string | number): Model => {
    // Relevant to server side only!
    if (!global?.__APP_LOOKUP_USER_CACHE__?.[slugOrId]) {
        return
    }
    return global?.__APP_LOOKUP_USER_CACHE__[slugOrId].result
}

export const getStateUser = (id: number) => USERSSTATE.users[id]

export const getUser = (identifier: string | number) =>
    getStateUser(resolveID(identifier)) ||
    getServerCachedUser(resolveID(identifier)) ||
    getServerCachedUser(resolveSlug(identifier))

export const getUsersState = () => USERSSTATE

/* Video */
export const getVideoState = () => VIDEOSTATE.video
